import { isEmpty, symmetricDifference } from 'ramda'

import { MY_ACCOUNT } from '../../../../constants'

export const getCreditCardAddResponse = response => response?.data?.creditcardAdd || ''

export const getCreditCardUpdateResponse = response => (
  response?.data?.creditcardUpdate || { paymentMethodId: '', iframe: '' }
)

export const checkCardLimit = tableData => (
  tableData.filter(card => !isEmpty(card)).length >= MY_ACCOUNT.CREDIT_CARD_LIMIT
)

export const checkTableData = (tableData, accountCreditCards) => (
  symmetricDifference(tableData, accountCreditCards)
    .filter(card => !isEmpty(card))
    .length
)

const hasEmptyPlaceholder = tableData => tableData.some(card => isEmpty(card))

export const handleTableDataForIframes = (tableData, isAddNew) => {
  if (isAddNew && !hasEmptyPlaceholder(tableData)) {
    return [{}, ...tableData]
  }

  if (!isAddNew && hasEmptyPlaceholder(tableData)) {
    return tableData.filter(card => !isEmpty(card))
  }

  return tableData
}

export const getProductType = ({ column, columnName }) => ({
  useForPurchases: 'TVOD',
  useForSubscriptions: 'SVOD'
}[(column && column.id) || columnName])

export const isCreditCardExpired = ({ expMonth, expYear }) => {
  const month = Number(expMonth)
  const year = Number(expYear)

  if (!month || !year) return false

  // Cards expire on the first day of the following month, e.g. 12/24 expires on 1 Jan 2025.
  const firstDayAfterExpiry = new Date(year, month, 1)
  return firstDayAfterExpiry <= new Date()
}

// Prevent removing subscription default cards and unexpired rental default cards.
// Expired rental only default cards can be removed.
export const shouldPreventCreditCardRemoval = creditCard => (
  creditCard.useForSubscriptions ||
  (creditCard.useForPurchases && !isCreditCardExpired(creditCard))
)
